import { useField } from "formik"
import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { DeliveryFulfillmentType, DynamicConfigField, DynamicConfigKey } from "../../form/formTypes"
import { SelectedMainUserState } from "../../../createOrderTypes"
import { DeliveryLocationAutocomplete } from "../deliveryLocation/DeliveryLocationAutocomplete"
import { OtherDeliveryLocationField } from "../deliveryLocation/OtherDeliveryLocationField"

const useStyles = makeStyles()((theme) => ({
    fieldLabel: {
        color: theme.palette.tailwind.slate[600],
    },
}))

type DeferredDeliveryLocationFieldsProps = Readonly<{
    user: SelectedMainUserState
    deliveryFields: {
        deliveryLocations?: DynamicConfigField
        otherDeliveryLocation?: DynamicConfigField
    }
    showOtherLocationField: boolean
    setShowOtherLocationField: (v: boolean) => void
    hasMeetingLocationRequired: boolean
    defaultButtonClass?: string
}>

export function DeferredDeliveryLocationFields({
    user,
    deliveryFields,
    showOtherLocationField,
    setShowOtherLocationField,
    hasMeetingLocationRequired,
    defaultButtonClass,
}: DeferredDeliveryLocationFieldsProps) {
    const { classes } = useStyles()
    const [{ value: deliveryType = "" }] = useField<DeliveryFulfillmentType>(DynamicConfigKey.DELIVERY_TYPE)

    const showLocation =
        (deliveryType === DeliveryFulfillmentType.DELIVERY || hasMeetingLocationRequired) &&
        deliveryFields.deliveryLocations
    const isMeetingLocation = hasMeetingLocationRequired && deliveryType !== DeliveryFulfillmentType.DELIVERY

    if (!showLocation) return null

    return (
        <>
            <Stack gap=".5rem">
                <LocalizedStrict id="create-order-extra-services-additional-fields-location-label">
                    <Typography variant="body2" className={classes.fieldLabel}>
                        Where is the meeting located?
                    </Typography>
                </LocalizedStrict>
                <DeliveryLocationAutocomplete
                    userId={user.userId}
                    config={deliveryFields.deliveryLocations!}
                    isMeetingLocation={isMeetingLocation}
                />
            </Stack>
            {deliveryFields.otherDeliveryLocation && (
                <OtherDeliveryLocationField
                    config={deliveryFields.otherDeliveryLocation}
                    showOtherLocationField={showOtherLocationField}
                    setShowOtherLocationField={setShowOtherLocationField}
                    defaultButtonClass={defaultButtonClass}
                    isMeetingLocation={isMeetingLocation}
                />
            )}
        </>
    )
}

